import { cx } from "./cx";

export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cx("block animate-skeleton rounded-md bg-surface-3", className)} />;
}

export function SkeletonRows({ rows = 6, columns }: { rows?: number; columns: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} aria-hidden="true">
          {Array.from({ length: columns }, (_, c) => (
            <td key={c} className="h-10 border-b border-divider px-2.5">
              <Skeleton className={cx("h-3", c === 0 ? "w-3/4" : "w-1/2")} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
